var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"ceping"},[_vm._v("公司介绍")]),_vm._v(" "),_c('div',{ref:"editor",staticClass:"contents mavonEditor md",staticStyle:{"height":"auto","display":"block","width":"80%","padding":"20px 10% 60px"},domProps:{"innerHTML":_vm._s(_vm.contents)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683ef31d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutus/index.vue
// module id = null
// module chunks = 